window.afterUpdateCartSlid = (that) => {
    const customizedSKUs = ["Z00377", "C0110"];  // 要判断的 SKU

    that.cart.items.forEach((item, index) => {
        let variant = that._getVariant(item.variant_id),
            itemEl = document.querySelector(`[ymq-cart-app-item-line="${index + 1}"]`);

        if (!itemEl || !variant) return;

        // 找到商品图片容器
        let imageEl = itemEl.querySelector('.ymq-cart-app-item-image .ymq-cart-app-image-info');
        if (!imageEl) return;

        // 如果 SKU 匹配
        if (customizedSKUs.includes(variant.sku)) {

            // 避免重复添加
            if (!imageEl.querySelector(".customized-label-inside")) {

                let tag = document.createElement("div");
                tag.className = "customized-label-inside";
                tag.innerText = "Customized";

                // 将标签放到图片 div 的最后
                imageEl.appendChild(tag);
            }
        }
    });
};
